// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";

import { isGenerativeAiAgentIdLogsDetailResultItem } from "../generativeAiAgentIdLogsDetail/validators";

export const isGenerativeAiAgentIdLogsBatchDetailsResult = objectOf({
  results: arrayOf(isGenerativeAiAgentIdLogsDetailResultItem),
});
